angular.module('App.video.staleVideo', [])
    .controller('VideoCtrl', ['$scope', 'formResponseIdService', '$location', '$timeout', '$rootScope',
        function($scope, formResponseIdService, $location, $timeout, $rootScope) {
            $rootScope.forceShowHeader = true;
            $scope.type = $location.search().type || $location.path().split('/')[2];
            $scope.interviewId = $location.search().interviewId || $location.path().split('/')[3];
            $scope.modal = {};
            formResponseIdService.setId($scope.interviewId);
            $rootScope.interviewId = $scope.interviewId;
            $scope.lazyLoading = {};

            $scope.requestExtension = function() {
                if (angular.isUndefined($scope.lazyLoading.requestExtensionUrl)) {
                    $scope.lazyLoading.requestExtensionUrl = 'requestExtension.html';
                } else {
                    $scope.requestExtensionUrlLoaded();
                }
            };

            $scope.requestExtensionUrlLoaded = function() {
                $timeout(function() {
                    $rootScope.$broadcast('requestExtensionModalClick', $scope.interviewId);
                }, 100);
            };

            $scope.watchVideo = function() {
                $location.path('/Playback/actualInterview/' + $scope.interviewId);
            };

            $scope.hideModals = function() {
                $scope.modal = {};
                $rootScope.$broadcast('hidingVideoModals');
            };
        }
    ]);
